module.exports = __webpack_public_path__ + "img/expand_64-1.d41d8cd9.svg";